import { ModalSelectSupplierReceivementType } from './ModalSelectSupplierReceivementType'

export default ModalSelectSupplierReceivementType
